import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { cn } from '@/frontend/utils';
type CppLogoProps = React.SVGProps<SVGSVGElement> & {
  size?: number;
  color?: string;
};
export const CppLogo: React.FC<CppLogoProps> = t0 => {
  const $ = _c(24);
  let props;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== t0) {
    const {
      size: t10,
      width,
      height,
      ...t11
    } = t0;
    props = t11;
    const size = t10 === undefined ? 32 : t10;
    t1 = "http://www.w3.org/2000/svg";
    t2 = width ?? size;
    t3 = height ?? size;
    t4 = "0 0 32 32";
    t5 = "none";
    t6 = "true";
    t7 = "img";
    t8 = "C++ logo";
    t9 = cn("stroke-[#3B82F6]", props.className);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <g clipPath="url(#clip0_7979_16393)"><path d="M24 16H29.3333" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M26.667 13.333V18.6663" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M14.667 16H20.0003" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M17.333 13.333V18.6663" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /><path d="M12.0003 12C12.0003 10.9391 11.5789 9.92172 10.8288 9.17157C10.0786 8.42143 9.06119 8 8.00033 8H7.33366C6.09598 8 4.909 8.49167 4.03383 9.36684C3.15866 10.242 2.66699 11.429 2.66699 12.6667V19.3333C2.66699 20.571 3.15866 21.758 4.03383 22.6332C4.909 23.5083 6.09598 24 7.33366 24H8.00033C9.06119 24 10.0786 23.5786 10.8288 22.8284C11.5789 22.0783 12.0003 21.0609 12.0003 20" strokeWidth="2.66667" strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <defs><clipPath id="clip0_7979_16393"><rect width="32" height="32" fill="white" /></clipPath></defs>;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== props || $[14] !== t1 || $[15] !== t2 || $[16] !== t3 || $[17] !== t4 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t8 || $[22] !== t9) {
    t12 = <svg xmlns={t1} width={t2} height={t3} viewBox={t4} fill={t5} aria-hidden={t6} role={t7} aria-label={t8} className={t9} {...props}>{t10}{t11}</svg>;
    $[13] = props;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};